<script lang="ts">
    import { onDestroy } from 'svelte';

    export let name: string;
    export let errors: Record<string, string[]>;
    export let label: string = '';
    export let accept: string = '';
    export let multiple: boolean = false;
    export let disabled: boolean = false;
    export let required: boolean = false;

    errors[name] = [];

    const validate = (files: FileList | null) => {
        errors[name] = [];
        if (required && (!files || files.length === 0)) {
            errors[name].push('Please select a file');
        }
    };
    validate(null);

    const handleChange = (e: Event) => validate((e.currentTarget as HTMLInputElement).files);

    onDestroy(() => { errors[name] = []; });
</script>

<label class="form-field">
    {#if label}<span class="label-text">{label}</span>{/if}
    <input
        type="file"
        {name}
        {accept}
        {multiple}
        {disabled}
        {required}
        on:change={handleChange}
        class:error={errors[name].length > 0}
        on:blur
    />
    <span class="field-errors">
        {#each errors[name] as err}<span>{err}</span>{/each}
    </span>
</label>
